import { environment } from 'src/environments/environment';

export const API_BASE_URL = environment.baseUrl;